// import { useState, useEffect } from "react";

// import { loadStorageLocationtypeList,  loadWarehouseLocationtypeListByStatus } from "../../services/warehouseService";

// const useStorageLocationTypeList = (status,editID) => {

//     const [storageLocationTypes, setStorageLocationTypes] = useState([]);
//     const [selectedStorageLocationType, setSelectedStorageLocationType] = useState(null);
//     const [selectedStorageLocationTypeID, setSelectedStorageLocationTypeID] = useState(null);
//     const [isStorageLocationTypeDataLoaded, setIsStorageLocationTypeDataLoaded] = useState(false);

//     // Fetch department data
//     const fetchStorageLocationTypeList = async (selectedID = null) => {
//         try {
//             let data;
//             if (status !== null) {
//                 const para = {
//                     p_company_id: localStorage.getItem("companyid"),
//                     p_plant_id: 1,
//                     p_status: status
//                 };

//                 data = await loadWarehouseLocationtypeListByStatus(para);
//             } else {
//                 data = await loadStorageLocationtypeList({
//                     p_companyid: localStorage.getItem("companyid")
//                 });
//             }

//             if (data && data.length > 0) {
//                 setStorageLocationTypes(data);
//                 const initialStorageLocationType = data.find((dept) => dept.location_type_id === selectedID);

//                 if (initialStorageLocationType) { // ✅ Corrected check
//                     setSelectedStorageLocationType(initialStorageLocationType);
//                     setSelectedStorageLocationTypeID(initialStorageLocationType.location_type_id);
//                     setIsStorageLocationTypeDataLoaded(true);
//                 }

//             }
//         } catch (error) {
//             // CallMessage("error", error.message, "Error");
//         }
//     };

//     // Load storage location types when the component mounts
//     useEffect(() => {
//         if (!isStorageLocationTypeDataLoaded) {
//             const loadStorageLocationTypes = async () => {
//                 await fetchStorageLocationTypeList();
//             };
//             loadStorageLocationTypes();
//         }
//     }, [isStorageLocationTypeDataLoaded, editID]);

//     // Function to load storage location type based on selected ID
//     const loadStorageLocationTypeByID = async (selectedID) => {
//         await fetchStorageLocationTypeList(selectedID);
//     };

//     return {
//         storageLocationTypes,
//         selectedStorageLocationType,
//         setSelectedStorageLocationType,
//         selectedStorageLocationTypeID,
//         setSelectedStorageLocationTypeID,
//         loadStorageLocationTypeByID,
//     };
// };

// export default useStorageLocationTypeList;

import { useState, useEffect } from "react";
import {
  loadStorageLocationtypeList,
  loadWarehouseLocationtypeListByStatus,
} from "../../services/warehouseService";

const useStorageLocationTypeList = (status, editID) => {
  const [storageLocationTypes, setStorageLocationTypes] = useState([]);
  const [selectedStorageLocationType, setSelectedStorageLocationType] = useState(null);
  const [selectedStorageLocationTypeID, setSelectedStorageLocationTypeID] = useState(null);
  const [isStorageLocationTypeDataLoaded, setIsStorageLocationTypeDataLoaded] = useState(false);

  const fetchStorageLocationTypeList = async (selectedID = null) => {
    try {
      let data = [];

      // 🔹 Step 1: Try to load by status (active/inactive)
      if (status !== null) {
        const para = {
          p_company_id: localStorage.getItem("companyid"),
          p_plant_id: 1,
          p_status: status,
        };
        data = await loadWarehouseLocationtypeListByStatus(para);
      } else {
        data = await loadStorageLocationtypeList({
          p_companyid: localStorage.getItem("companyid"),
        });
      }

      // 🔹 Step 2: Fallback — if no active found, load all
      if ((!data || data.length === 0) && status === true && selectedID) {
        data = await loadStorageLocationtypeList({
          p_companyid: localStorage.getItem("companyid"),
        });
      }

      // 🔹 Step 3: Handle and set data
      if (data && data.length > 0) {
        let updatedList = [...data];
        let initialType = data.find((t) => t.location_type_id === selectedID);

        if (!initialType && selectedID) {
          const allData = await loadStorageLocationtypeList({
            p_companyid: localStorage.getItem("companyid"),
          });
          const inactiveType = allData.find((t) => t.location_type_id === selectedID);
          if (inactiveType) {
            updatedList.push(inactiveType);
            initialType = inactiveType;
          }
        }

        setStorageLocationTypes(updatedList);
        if (initialType) {
          setSelectedStorageLocationType(initialType);
          setSelectedStorageLocationTypeID(initialType.location_type_id);
        }

        setIsStorageLocationTypeDataLoaded(true);
      } else {
        // 🔹 Step 4: Handle case where no records exist
        setSelectedStorageLocationType(null);
        setSelectedStorageLocationTypeID(null);
        setStorageLocationTypes([]);
        setIsStorageLocationTypeDataLoaded(true);
      }
    } catch (error) {
      console.error("Error fetching storage location types:", error);
    }
  };

  // 🔹 Step 5: Load on mount
  useEffect(() => {
    if (!isStorageLocationTypeDataLoaded && editID === 0) {
      fetchStorageLocationTypeList();
    }
  }, [isStorageLocationTypeDataLoaded, editID]);

  // 🔹 Step 6: Load by selected ID
  const loadStorageLocationTypeByID = async (selectedID) => {
    await fetchStorageLocationTypeList(selectedID);
  };

  return {
    storageLocationTypes,
    selectedStorageLocationType,
    selectedStorageLocationTypeID,
    setSelectedStorageLocationType,
    setSelectedStorageLocationTypeID,
    setIsStorageLocationTypeDataLoaded,
    loadStorageLocationTypeByID,
  };
};

export default useStorageLocationTypeList;

